"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationStatus = void 0;
var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["READ"] = "READ";
    NotificationStatus["UNREAD"] = "UNREAD";
})(NotificationStatus || (exports.NotificationStatus = NotificationStatus = {}));
